module.exports = __webpack_public_path__ + "media/images/weather/343_day-964335e150fe96940f5dfccc75b838dc.png";